import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  NoSuchElementException679xzhnp5bpj as NoSuchElementException,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { toString1pkumu07cwy4m as toString } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { Collection1k04j3hzsbod0 as Collection } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import {
  toSet2orjxp16sotqu as toSet,
  singleOrNull21olsob387p54 as singleOrNull,
  first58ocm7j58k3q as first,
  singleOrNullrknfaxokm1sl as singleOrNull_0,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { trimIndent1qytc1wvt8suh as trimIndent } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/Indent.mjs';
import {
  TextAndFileInputDialog30838dtq38cw5 as TextAndFileInputDialog,
  Submission1tz7ozccph0bt as Submission,
} from './TextInputDialog.mjs';
import { println2shhhgwwt4c61 as println } from '../../../../../kotlin-kotlin-stdlib/kotlin/io/console.mjs';
import {
  await1kke5zj2piplv as await_0,
  awaitqeg6zusi9ora as await_1,
} from '../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { Signal1973xs1vkmdcb as Signal } from '../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import { PrimaryButtonSemantic_getInstance2oopjxbt9oc9b as PrimaryButtonSemantic_getInstance } from '../theming/buttons.mjs';
import { RowOrCol3a33s3yce2tuv as RowOrCol } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ContainingView.commonHtml.mjs';
import { get_centered1xfu6or5nc0lq as get_centered } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import { Checkbox2he0oy51inwu6 as Checkbox } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Checkbox.commonHtml.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import { BodySemantic_getInstancembkce4y4wobt as BodySemantic_getInstance } from '../theming/Titles.mjs';
import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import { GenericDialog2kroovzplfo3s as GenericDialog } from './GenericDialog.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { get_dialogStackleaqvayyucjw as get_dialogStack } from '../components/nav/crowpay.mjs';
import { get_session9cytjmfbg8nd as get_session } from '../../sdk/UserSession.mjs';
import {
  initMetadataForFunctionReferencen3g5fpj34t8u as initMetadataForFunctionReference,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { resolveProjectAttachments1r3ylk2p3xmwv as resolveProjectAttachments } from '../components/files/attachmentFilePreview.mjs';
import {
  RequestComplete2fbpvksxlxjbf as RequestComplete,
  Remedy1wqpxp6byw9t6 as Remedy,
  RemedyComplete1j0nrocri3mi3 as RemedyComplete,
} from '../../../../../crowpay-shared/com/crowpay/completionResponse/CompletionResponse.mjs';
import { serializable2l0a6bc0gtxdw as serializable } from '../../../../../crowpay-shared/com/crowpay/completionResponse/serialization.mjs';
import {
  LineItemCompletionMessage2zpi6q6jke1no as LineItemCompletionMessage,
  IncidentMessage1zg9aeg4hgwtu as IncidentMessage,
} from '../../../../../crowpay-shared/com/crowpay/databaseModels.mjs';
import { CompletionFlowPermissionsj7m9votfuuvc as CompletionFlowPermissions } from '../../../../../crowpay-shared/com/crowpay/completionResponse/CompletionFlowPermissions.mjs';
import { asReversed308kw52j6ls1u as asReversed } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ReversedViews.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { ViewWriter2xfqkrnuqv5cx as ViewWriter } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/ViewWriter.mjs';
import {
  Handled19mgago2u0m72 as Handled,
  Remedy2jczhqm350rbv as Remedy_0,
  RemedyHandled1fest6c8tpi44 as RemedyHandled,
} from '../../../../../crowpay-shared/com/crowpay/incidentResponse/IncidentResponseType.mjs';
import { serializableajawjsrnxxet as serializable_0 } from '../../../../../crowpay-shared/com/crowpay/incidentResponse/serialization.mjs';
import { CompletionRequest2ew7c02dda2ep as CompletionRequest } from '../../../../../crowpay-shared/com/crowpay/supportModels.mjs';
import { delayolwo40i9ucjz as delay } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Delay.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function WorkItemRequestSignOffDialog(items, history, scope, dismiss) {
  scope = scope === VOID ? null : scope;
  var tmp;
  if (dismiss === VOID) {
    tmp = WorkItemRequestSignOffDialog$lambda;
  } else {
    tmp = dismiss;
  }
  dismiss = tmp;
  // Inline function 'kotlin.collections.isNotEmpty' call
  // Inline function 'kotlin.require' call
  if (!!items.i1()) {
    var message = 'RequestSignOffDialog needs at least 1 LineItem';
    throw IllegalArgumentException().a1(toString(message));
  }
  var tmp$ret$3;
  $l$block_0: {
    // Inline function 'kotlin.collections.none' call
    var tmp_0;
    if (isInterface(history, Collection())) {
      tmp_0 = history.i1();
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp$ret$3 = true;
      break $l$block_0;
    }
    var _iterator__ex2g4s = history.m1();
    while (_iterator__ex2g4s.n1()) {
      var element = _iterator__ex2g4s.o1();
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList().u(collectionSizeOrDefault(items, 10));
      var _iterator__ex2g4s_0 = items.m1();
      while (_iterator__ex2g4s_0.n1()) {
        var item = _iterator__ex2g4s_0.o1();
        var tmp$ret$4 = item.kf9_1;
        destination.v(tmp$ret$4);
      }
      if (destination.t1(element.a6h_1)) {
        tmp$ret$3 = false;
        break $l$block_0;
      }
    }
    tmp$ret$3 = true;
  }
  var firstSignOff = tmp$ret$3;
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_0 = ArrayList().u(collectionSizeOrDefault(items, 10));
  var _iterator__ex2g4s_1 = items.m1();
  while (_iterator__ex2g4s_1.n1()) {
    var item_0 = _iterator__ex2g4s_1.o1();
    var tmp$ret$8 = item_0.jfy();
    destination_0.v(tmp$ret$8);
  }
  var tmp0_elvis_lhs = singleOrNull(toSet(destination_0));
  var tmp_1;
  if (tmp0_elvis_lhs == null) {
    throw IllegalArgumentException().a1('All line items must be from the same project');
  } else {
    tmp_1 = tmp0_elvis_lhs;
  }
  var project = tmp_1;
  var tmp2_elvis_lhs = scope == null ? null : scope.m7z_1;
  var tmp_2 = 'Request Sign-Off: ' + (tmp2_elvis_lhs == null ? first(items).lf9_1 : tmp2_elvis_lhs);
  var tmp_3 = firstSignOff ? trimIndent('\n                Are you certain this ' + (!(scope == null) ? 'scope' : 'item') + ' is ready for sign-off?\n\n                Submitting for sign-off will send an approval request to the client. Ensure ' + (items.p1() > 1 ? 'all items are' : 'the item is') + " fully complete and the client is aware of your request.\n                \n                If minor loose ends remain, notify the client they\u2019ve been added to the punch list for project closeout.\n                \n                Tip: Include an explanation for why you're signing off along with pictures to help the client approve and release payment faster.\n            ") : 'Before resubmitting for approval, ensure the work is fully complete and meets the client\u2019s expectations.\n\nIf the client does not approve again, they may escalate the issue, which could lead to further delays and formal resolution steps. Resubmit only if you\u2019ve addressed all feedback and communicated clearly with the client.\n\nTips:\n- Attach updated pictures or documentation to help the client approve your work faster.\n- If small, low-value items remain (e.g., a sprinkler clock on backorder), communicate with the client and list them as punch list or warranty items. This reassures the client that loose ends will be resolved during project closeout.';
  var tmp_4 = WorkItemRequestSignOffDialog$slambda_0();
  return new (TextAndFileInputDialog())(tmp_2, tmp_3, 'Request Sign-Off', VOID, VOID, 'Provide any additional context for this sign-off', tmp_4, VOID, WorkItemRequestSignOffDialog$slambda_2(dismiss, scope, project, items, history));
}
function IncidentRequestSignOffDialog(incident, permissions, dismiss) {
  println('Making dialog');
  var tmp = IncidentRequestSignOffDialog$slambda_0();
  return new (TextAndFileInputDialog())('Request Sign-Off', 'Incident request sign-off dialog message', 'Request Sign-Off', VOID, VOID, 'Provide any additional context for this sign-off', tmp, VOID, IncidentRequestSignOffDialog$slambda_2(dismiss, incident, permissions));
}
function *_generator_RequestFinalCompletionDialog__bzmvul(data, $completion) {
  var tmp;
  var tmp_0 = await_0(data.ugm(), $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var tmp0 = tmp_0;
  var tmp$ret$0;
  $l$block_0: {
    // Inline function 'kotlin.collections.any' call
    var tmp_1;
    if (isInterface(tmp0, Collection())) {
      tmp_1 = tmp0.i1();
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      tmp$ret$0 = false;
      break $l$block_0;
    }
    var _iterator__ex2g4s = tmp0.m1();
    while (_iterator__ex2g4s.n1()) {
      var element = _iterator__ex2g4s.o1();
      if (element.r7w_1 && element.s7w_1 == null) {
        tmp$ret$0 = true;
        break $l$block_0;
      }
    }
    tmp$ret$0 = false;
  }
  if (tmp$ret$0) {
    tmp = GenericDialog().bgh('Required Tasks Incomplete', "Unable to proceed with final completion.\n\nAll 'required' punch list tasks must be completed before you can request final completion. Return to the Punch List to resolve outstanding items.");
  } else {
    var autoRelease = Signal().fak(true);
    var tmp_2 = PrimaryButtonSemantic_getInstance();
    var tmp_3 = ($this$TextAndFileInputDialog) => {
      // Inline function 'com.lightningkite.kiteui.views.direct.row' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view = new (RowOrCol())($this$TextAndFileInputDialog.pc());
      var tmp0_elvis_lhs = $this$TextAndFileInputDialog.cbb_1;
      var p = tmp0_elvis_lhs == null ? $this$TextAndFileInputDialog : tmp0_elvis_lhs;
      $this$TextAndFileInputDialog.ebb(p, view);
      view.xbm(false);
      var tmp = get_centered(view);
      // Inline function 'com.lightningkite.kiteui.views.direct.checkbox' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_0 = new (Checkbox())(view.pc());
      var tmp0_elvis_lhs_0 = view.cbb_1;
      var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
      view.ebb(p_0, view_0);
      view_0.xah(view_0.cbk_1, autoRelease);
      view.fbb(p_0, view_0);
      view.jbb(tmp, view_0);
      var tmp_0 = get_centered(view);
      // Inline function 'com.crowpay.views.theming.body' call
      // Inline function 'com.lightningkite.kiteui.views.direct.text' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_1 = new (TextView())(view.pc());
      var tmp0_elvis_lhs_1 = view.cbb_1;
      var p_1 = tmp0_elvis_lhs_1 == null ? view : tmp0_elvis_lhs_1;
      view.ebb(p_1, view_1);
      view_1.jba(view_1.ob6_1.ybe(BodySemantic_getInstance()));
      // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
      var value = "Automatically complete the project and release retention funds after 14 days if there's no response. The timer won't start until any open issues have been responded to.";
      var tmp_1 = view_1.tb5_1;
      var tmp_2;
      // Inline function 'kotlin.text.isEmpty' call
      if (charSequenceLength(value) === 0) {
        tmp_2 = '\xA0';
      } else {
        tmp_2 = value;
      }
      tmp_1.fbu(tmp_2);
      view.fbb(p_1, view_1);
      view.jbb(tmp_0, view_1);
      $this$TextAndFileInputDialog.fbb(p, view);
      return Unit_instance;
    };
    tmp = new (TextAndFileInputDialog())('Submit For Project Completion?', '\u2022 Ensure all "required" punch tasks are completed.\n\u2022 Confirm the site is clean and closed.\n\u2022 Consider checking with client for satisfaction before submitting.', 'Request Project Completion', tmp_2, 0, VOID, VOID, tmp_3, RequestFinalCompletionDialog$slambda_0(data, autoRelease));
  }
  return tmp;
}
function RequestFinalCompletionDialog(data, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_RequestFinalCompletionDialog__bzmvul.bind(VOID, data), $completion);
}
function WorkItemRequestSignOffDialog$lambda(_this__u8e3s4, it) {
  get_dialogStack().ngd();
  return Unit_instance;
}
function *_generator_invoke__zhh2q8($this, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_session();
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp$ret$0 = tmp;
  return LiveApi2$Api2LineItemLive$uploadFileForRequest$ref_0(tmp$ret$0.tfw().efg_1);
}
var LiveApi2$Api2LineItemLive$uploadFileForRequest$refClass;
function LiveApi2$Api2LineItemLive$uploadFileForRequest$ref() {
  if (LiveApi2$Api2LineItemLive$uploadFileForRequest$refClass === VOID) {
    class $ {
      constructor(p0) {
        this.uih_1 = p0;
      }
      sao($completion) {
        return this.uih_1.jfi($completion);
      }
    }
    initMetadataForFunctionReference($, VOID, VOID, [0]);
    LiveApi2$Api2LineItemLive$uploadFileForRequest$refClass = $;
  }
  return LiveApi2$Api2LineItemLive$uploadFileForRequest$refClass;
}
function LiveApi2$Api2LineItemLive$uploadFileForRequest$ref_0(p0) {
  var i = new (LiveApi2$Api2LineItemLive$uploadFileForRequest$ref())(p0);
  var l = ($completion) => i.sao($completion);
  l.callableName = 'uploadFileForRequest';
  l.$arity = 0;
  return l;
}
var WorkItemRequestSignOffDialog$slambdaClass;
function WorkItemRequestSignOffDialog$slambda() {
  if (WorkItemRequestSignOffDialog$slambdaClass === VOID) {
    class $ {
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    WorkItemRequestSignOffDialog$slambdaClass = $;
  }
  return WorkItemRequestSignOffDialog$slambdaClass;
}
function WorkItemRequestSignOffDialog$slambda_0() {
  var i = new (WorkItemRequestSignOffDialog$slambda())();
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
function *_generator_invoke__zhh2q8_0($this, $this$TextAndFileInputDialog, submission, $completion) {
  if (submission == null) {
    $this.vih_1($this$TextAndFileInputDialog, false);
    return Unit_instance;
  }
  var tmp = resolveProjectAttachments(submission.yh2_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var files = tmp;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_session();
  var tmp_0 = await_0(this_0, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var session = tmp_0;
  var tmp0_safe_receiver = $this.wih_1;
  var tmp_1;
  if (tmp0_safe_receiver == null) {
    tmp_1 = null;
  } else {
    // Inline function 'kotlin.takeIf' call
    var tmp_2;
    if (tmp0_safe_receiver.p7z_1) {
      tmp_2 = tmp0_safe_receiver;
    } else {
      tmp_2 = null;
    }
    tmp_1 = tmp_2;
  }
  var tmp1_safe_receiver = tmp_1;
  var tmp_3;
  if (tmp1_safe_receiver == null) {
    tmp_3 = null;
  } else {
    // Inline function 'kotlin.let' call
    var tmp_4 = session.tfw().vfg_1.afr(tmp1_safe_receiver.k7z_1, new (LineItemCompletionMessage())(VOID, $this.xih_1, tmp1_safe_receiver.k7z_1, session.efv_1, false, serializable(new (RequestComplete())(session.ufw())), submission.xh2_1, files), $completion);
    if (tmp_4 === get_COROUTINE_SUSPENDED())
      tmp_4 = yield tmp_4;
    tmp_3 = Unit_instance;
  }
  if (tmp_3 == null) {
    // Inline function 'kotlin.let' call
    var it = first($this.yih_1);
    var tmp_5;
    var tmp0_safe_receiver_0 = singleOrNull_0($this.yih_1);
    var tmp_6;
    if (tmp0_safe_receiver_0 == null) {
      tmp_6 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'com.lightningkite.reactive.context.invoke' call
      var this_1 = session.pfw_1;
      var tmp_7 = await_0(this_1, $completion);
      if (tmp_7 === get_COROUTINE_SUSPENDED())
        tmp_7 = yield tmp_7;
      var tmp0_safe_receiver_1 = tmp_7.m88_1;
      tmp_6 = (new (CompletionFlowPermissions())(tmp0_safe_receiver_0.hf9_1, false, tmp0_safe_receiver_1 == null ? null : tmp0_safe_receiver_1.j8c_1, $this.zih_1)).z8x();
    }
    if (tmp_6 === true) {
      // Inline function 'kotlin.collections.firstNotNullOf' call
      var tmp0 = asReversed($this.zih_1);
      var tmp$ret$9;
      $l$block: {
        // Inline function 'kotlin.collections.firstNotNullOfOrNull' call
        var _iterator__ex2g4s = tmp0.m1();
        while (_iterator__ex2g4s.n1()) {
          var element = _iterator__ex2g4s.o1();
          var tmp_8 = element.f8w();
          var result = tmp_8 instanceof Remedy() ? tmp_8 : null;
          if (!(result == null)) {
            tmp$ret$9 = result;
            break $l$block;
          }
        }
        tmp$ret$9 = null;
      }
      var tmp0_elvis_lhs = tmp$ret$9;
      var tmp_9;
      if (tmp0_elvis_lhs == null) {
        throw NoSuchElementException().o('No element of the collection was transformed to a non-null value.');
      } else {
        tmp_9 = tmp0_elvis_lhs;
      }
      var tmp$ret$10 = tmp_9;
      tmp_5 = new (RemedyComplete())(tmp$ret$10);
    } else {
      tmp_5 = new (RequestComplete())(session.ufw());
    }
    var response = tmp_5;
    var tmp_10 = session.tfw().ffg_1.ofm(new (LineItemCompletionMessage())(VOID, $this.xih_1, it.kf9_1, session.efv_1, false, serializable(response), submission.xh2_1, files), $completion);
    if (tmp_10 === get_COROUTINE_SUSPENDED())
      tmp_10 = yield tmp_10;
    var tmp0_0 = tmp_10;
    // Inline function 'kotlin.also' call
    session.cfw_1.bft(tmp0_0);
  }
  $this.vih_1($this$TextAndFileInputDialog, true);
  return Unit_instance;
}
var WorkItemRequestSignOffDialog$slambdaClass_0;
function WorkItemRequestSignOffDialog$slambda_1() {
  if (WorkItemRequestSignOffDialog$slambdaClass_0 === VOID) {
    class $ {
      constructor($dismiss, $scope, $project, $items, $history) {
        this.vih_1 = $dismiss;
        this.wih_1 = $scope;
        this.xih_1 = $project;
        this.yih_1 = $items;
        this.zih_1 = $history;
      }
      ch3($this$TextAndFileInputDialog, submission, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_0.bind(VOID, this, $this$TextAndFileInputDialog, submission), $completion);
      }
      rd(p1, p2, $completion) {
        var tmp = p1 instanceof ViewWriter() ? p1 : THROW_CCE();
        return this.ch3(tmp, (p2 == null ? true : p2 instanceof Submission()) ? p2 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [2]);
    WorkItemRequestSignOffDialog$slambdaClass_0 = $;
  }
  return WorkItemRequestSignOffDialog$slambdaClass_0;
}
function WorkItemRequestSignOffDialog$slambda_2($dismiss, $scope, $project, $items, $history) {
  var i = new (WorkItemRequestSignOffDialog$slambda_1())($dismiss, $scope, $project, $items, $history);
  var l = ($this$TextAndFileInputDialog, submission, $completion) => i.ch3($this$TextAndFileInputDialog, submission, $completion);
  l.$arity = 2;
  return l;
}
function *_generator_invoke__zhh2q8_1($this, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_session();
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp$ret$0 = tmp;
  return LiveApi2$Api2IncidentLive$uploadFileForRequest$ref_0(tmp$ret$0.tfw().yff_1);
}
var LiveApi2$Api2IncidentLive$uploadFileForRequest$refClass;
function LiveApi2$Api2IncidentLive$uploadFileForRequest$ref() {
  if (LiveApi2$Api2IncidentLive$uploadFileForRequest$refClass === VOID) {
    class $ {
      constructor(p0) {
        this.aii_1 = p0;
      }
      sao($completion) {
        return this.aii_1.jfi($completion);
      }
    }
    initMetadataForFunctionReference($, VOID, VOID, [0]);
    LiveApi2$Api2IncidentLive$uploadFileForRequest$refClass = $;
  }
  return LiveApi2$Api2IncidentLive$uploadFileForRequest$refClass;
}
function LiveApi2$Api2IncidentLive$uploadFileForRequest$ref_0(p0) {
  var i = new (LiveApi2$Api2IncidentLive$uploadFileForRequest$ref())(p0);
  var l = ($completion) => i.sao($completion);
  l.callableName = 'uploadFileForRequest';
  l.$arity = 0;
  return l;
}
var IncidentRequestSignOffDialog$slambdaClass;
function IncidentRequestSignOffDialog$slambda() {
  if (IncidentRequestSignOffDialog$slambdaClass === VOID) {
    class $ {
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_1.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    IncidentRequestSignOffDialog$slambdaClass = $;
  }
  return IncidentRequestSignOffDialog$slambdaClass;
}
function IncidentRequestSignOffDialog$slambda_0() {
  var i = new (IncidentRequestSignOffDialog$slambda())();
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
function *_generator_invoke__zhh2q8_2($this, $this$TextAndFileInputDialog, submission, $completion) {
  if (submission == null) {
    $this.bii_1($this$TextAndFileInputDialog, false);
    return Unit_instance;
  }
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_session();
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var session = tmp;
  var tmp_0 = session.tfw().zff_1;
  var tmp0_incident = $this.cii_1.d63_1;
  var tmp1_project = $this.cii_1.e63_1;
  var tmp2_sender = session.efv_1;
  var tmp_1;
  if ($this.dii_1.q9d_1) {
    // Inline function 'kotlin.collections.firstNotNullOf' call
    var tmp0 = asReversed($this.dii_1.u8x());
    var tmp$ret$2;
    $l$block: {
      // Inline function 'kotlin.collections.firstNotNullOfOrNull' call
      var _iterator__ex2g4s = tmp0.m1();
      while (_iterator__ex2g4s.n1()) {
        var element = _iterator__ex2g4s.o1();
        var tmp_2 = element.f94();
        var result = tmp_2 instanceof Remedy_0() ? tmp_2 : null;
        if (!(result == null)) {
          tmp$ret$2 = result;
          break $l$block;
        }
      }
      tmp$ret$2 = null;
    }
    var tmp0_elvis_lhs = tmp$ret$2;
    var tmp_3;
    if (tmp0_elvis_lhs == null) {
      throw NoSuchElementException().o('No element of the collection was transformed to a non-null value.');
    } else {
      tmp_3 = tmp0_elvis_lhs;
    }
    var tmp$ret$3 = tmp_3;
    tmp_1 = serializable_0(new (RemedyHandled())(tmp$ret$3));
  } else {
    tmp_1 = serializable_0(new (Handled())());
  }
  var tmp3_typeSerializable = tmp_1;
  var tmp_4 = resolveProjectAttachments(submission.yh2_1, $completion);
  if (tmp_4 === get_COROUTINE_SUSPENDED())
    tmp_4 = yield tmp_4;
  var tmp4_attachments = tmp_4;
  var tmp5_message = submission.xh2_1;
  var tmp_5 = tmp_0.gfl(new (IncidentMessage())(VOID, tmp0_incident, tmp1_project, false, tmp2_sender, tmp3_typeSerializable, tmp5_message, tmp4_attachments), $completion);
  if (tmp_5 === get_COROUTINE_SUSPENDED())
    tmp_5 = yield tmp_5;
  $this.bii_1($this$TextAndFileInputDialog, true);
  return Unit_instance;
}
var IncidentRequestSignOffDialog$slambdaClass_0;
function IncidentRequestSignOffDialog$slambda_1() {
  if (IncidentRequestSignOffDialog$slambdaClass_0 === VOID) {
    class $ {
      constructor($dismiss, $incident, $permissions) {
        this.bii_1 = $dismiss;
        this.cii_1 = $incident;
        this.dii_1 = $permissions;
      }
      ch3($this$TextAndFileInputDialog, submission, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_2.bind(VOID, this, $this$TextAndFileInputDialog, submission), $completion);
      }
      rd(p1, p2, $completion) {
        var tmp = p1 instanceof ViewWriter() ? p1 : THROW_CCE();
        return this.ch3(tmp, (p2 == null ? true : p2 instanceof Submission()) ? p2 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [2]);
    IncidentRequestSignOffDialog$slambdaClass_0 = $;
  }
  return IncidentRequestSignOffDialog$slambdaClass_0;
}
function IncidentRequestSignOffDialog$slambda_2($dismiss, $incident, $permissions) {
  var i = new (IncidentRequestSignOffDialog$slambda_1())($dismiss, $incident, $permissions);
  var l = ($this$TextAndFileInputDialog, submission, $completion) => i.ch3($this$TextAndFileInputDialog, submission, $completion);
  l.$arity = 2;
  return l;
}
function *_generator_invoke__zhh2q8_3($this, $this$TextAndFileInputDialog, submission, $completion) {
  if (submission == null) {
    get_dialogStack().ugg();
    return Unit_instance;
  }
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_session();
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var session = tmp;
  var tmp_0 = session.tfw().pfg_1;
  var tmp_1 = $this.eii_1.jf8();
  var tmp_2 = session.ufw();
  var tmp_3 = resolveProjectAttachments(submission.yh2_1, $completion);
  if (tmp_3 === get_COROUTINE_SUSPENDED())
    tmp_3 = yield tmp_3;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_1 = $this.fii_1;
  var tmp_4 = await_1(this_1, $completion);
  if (tmp_4 === get_COROUTINE_SUSPENDED())
    tmp_4 = yield tmp_4;
  var tmp$ret$1 = tmp_4;
  var tmp_5 = tmp_0.ifp(tmp_1, new (CompletionRequest())(tmp_2, submission.xh2_1, tmp_3, VOID, tmp$ret$1), $completion);
  if (tmp_5 === get_COROUTINE_SUSPENDED())
    tmp_5 = yield tmp_5;
  var tmp_6 = delay(100n, $completion);
  if (tmp_6 === get_COROUTINE_SUSPENDED())
    tmp_6 = yield tmp_6;
  get_dialogStack().ugg();
  return Unit_instance;
}
var RequestFinalCompletionDialog$slambdaClass;
function RequestFinalCompletionDialog$slambda() {
  if (RequestFinalCompletionDialog$slambdaClass === VOID) {
    class $ {
      constructor($data, $autoRelease) {
        this.eii_1 = $data;
        this.fii_1 = $autoRelease;
      }
      ch3($this$TextAndFileInputDialog, submission, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_3.bind(VOID, this, $this$TextAndFileInputDialog, submission), $completion);
      }
      rd(p1, p2, $completion) {
        var tmp = p1 instanceof ViewWriter() ? p1 : THROW_CCE();
        return this.ch3(tmp, (p2 == null ? true : p2 instanceof Submission()) ? p2 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [2]);
    RequestFinalCompletionDialog$slambdaClass = $;
  }
  return RequestFinalCompletionDialog$slambdaClass;
}
function RequestFinalCompletionDialog$slambda_0($data, $autoRelease) {
  var i = new (RequestFinalCompletionDialog$slambda())($data, $autoRelease);
  var l = ($this$TextAndFileInputDialog, submission, $completion) => i.ch3($this$TextAndFileInputDialog, submission, $completion);
  l.$arity = 2;
  return l;
}
//region block: exports
export {
  IncidentRequestSignOffDialog as IncidentRequestSignOffDialog16d4wye5a2av3,
  WorkItemRequestSignOffDialog as WorkItemRequestSignOffDialog3jlywf6lxbyl7,
  RequestFinalCompletionDialog as RequestFinalCompletionDialog3h3fcreklk22e,
};
//endregion

//# sourceMappingURL=RequestSignOffDialog.mjs.map
